import React, { useState, useEffect, Suspense } from 'react'
import { useParams } from 'react-router-dom'
import axios from 'axios'
import LoadingBar from 'react-top-loading-bar'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Header from '../Header/Header'
import Sidebar from '../Sidebar/Sidebar'
import Footer from '../Footer/Footer'
import styles from '../../App.module.css'
import classes from './Group.module.css'
import SingleGroup from '../Global/SingleGroup'
import SingleWeblink from '../Global/SingleWeblink'
import EmptyContent from '../Global/EmptyContent';

function Groups() {
    const { gid } = useParams();
    const [groups, setGroups] = useState([]);
    const [progress, setProgress] = useState(10);

    useEffect(() => {
      try{
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }catch(ex){}
    }, []);

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/api/group.php?limit=12&gid=${gid}`)
        .then(response => {
            setGroups(response.data);
            setProgress(100);
        })
    }, [gid]);

    // console.log(groups);

  return (
    <>
      <LoadingBar
        color='#f11946'
        progress={progress}
        onLoaderFinished={() => setProgress(0)}
      />
      <Header />
      <ToastContainer />
      <div className={styles.main_body}>
        <Suspense fallback="<div>Please wait...</div>">
          <Sidebar />
        </Suspense>
        <Suspense fallback="<div>Please wait...</div>">
          <div className={styles.main_content + ` main-content`}>
            <ins className='adsbygoogle p-4 pb-0'
                style={{ display: 'block' }}
                data-ad-client='ca-pub-8126596259429304'
                data-ad-slot='5153011292'
                data-ad-format='auto'
            />
            <div className="groups-component p-4 mb-5">
              <div className={classes.sec_heading}>
                <h2 className='m-0'>Web Group</h2>
              </div>
              <div className={classes.groups}>
                {
                  groups && groups.map ? groups.map((group, index) => {
                      return (
                        <div key={index}>
                            {
                                SingleWeblink(group)
                            }
                        </div>
                      )
                  })
                  : <EmptyContent />
                }
              </div>
            </div>
            <Footer />
          </div>
        </Suspense>
      </div>
      </>
  )
}

export default Groups